import { CORPORATE_BALANCE_TEXT } from 'constants';
import { getLocalCurrencyStr } from '@beef/utils';

import { dictionary } from 'constants/dictionary';

// fixme @TODO перевести на luxon
export const getNextBillingDate = (
  billingDate,
  withYear = true,
  withTime = false,
  separator = '',
) => {
  if (!billingDate) {
    return null;
  }

  const initialDate = new Date(billingDate);
  const currentYear = new Date().getFullYear();
  const billingDateYear = initialDate.getFullYear();
  const billingDateHours = initialDate.getHours();
  const billingDateHMinutes = `${initialDate.getMinutes()}`;
  const billingTime = `${billingDateHours}:${billingDateHMinutes.padStart(2, '0')}`;
  let nextBillingDate = `${initialDate.getDate()} ${dictionary.monthRULocale[initialDate.getMonth()]}`;

  if (withTime) {
    nextBillingDate += `${separator} ${billingTime}`;
  }

  if (withYear && currentYear !== billingDateYear) {
    nextBillingDate += ` ${billingDateYear}`;
  }

  return nextBillingDate;
};

// Сообщение о состоянии баланса на дату
export const getBalanceDateText = (date = '', separator = '') => {
  const lastDate = getNextBillingDate(date, false, true, separator);

  if (!lastDate) {
    return '';
  }

  return `на ${lastDate} МСК`;
};

export const getBalanceValue = (balanceValue, dueDate = '', lastDate = '') => {
  if (!lastDate && !dueDate) {
    return getLocalCurrencyStr(balanceValue);
  }

  const text =
    dueDate ?
      `${CORPORATE_BALANCE_TEXT} ${getNextBillingDate(dueDate, false, false)}`
    : getBalanceDateText(lastDate, ',');
  return `${getLocalCurrencyStr(balanceValue)}, ${text}`;
};

const TEXT_LENGTH_LIMIT = 25;

export const getTextSize = ({
  text = '',
  limit = TEXT_LENGTH_LIMIT,
  max = 'size5-r-s',
  min = 'size6-r',
}) => (text.length <= limit ? max : min);
